import RoleHome from '../../components/RoleHome/RoleHome';
export default function DeveloperHome() {
  return <RoleHome role="developer" />;
}